import type { TicketMeta, TicketStatus } from '@/types';
import { CourseLink } from '@/components/CourseLink';

interface TicketRowProps {
  ticket: TicketMeta;
  status: TicketStatus;
  isCurrent?: boolean;
  onClick?: () => void;
}

/**
 * slot_t00_ftue_rewrite (7 JUN 2026 · Genie picks):
 *  - дефолтные эмодзи-иконки типов (📚 ★ ✎ 📝 …) убраны — тип виден текстовой
 *    пилюлей на десктопе, на мобиле скрыт (вариант «минимум»);
 *  - layout вынесен из inline-стилей в `.trow` (screens.css) — инлайн-грид
 *    нельзя было перекрыть мобильными медиа-правилами
 *    (`feedback_qa_studio_react_inline_style_specificity`);
 *  - ≤768px строка сжимается до «точка-статус · название · минуты».
 */
const KIND_LABEL: Record<string, { cls: string; label: string }> = {
  docs: { cls: 'lesson', label: 'урок' },
  master: { cls: 'master', label: 'master' },
  practice: { cls: 'practice', label: 'практика' },
  test: { cls: 'test', label: 'final' },
  bug: { cls: 'lesson', label: 'bug' },
  task: { cls: 'lesson', label: 'task' },
  feature: { cls: 'lesson', label: 'feature' },
  mission: { cls: 'master', label: 'mission' },
};

const STATUS_TO_CLASS: Record<TicketStatus, string> = {
  done: 'done',
  'in-progress': 'progress',
  todo: '',
  backlog: '',
  review: 'progress',
  locked: 'locked',
};

/** Sprint screen ticket row — layout `.trow` + colors `.ticket` (screens.css). */
export function TicketRow({ ticket, status, isCurrent, onClick }: TicketRowProps) {
  const meta = KIND_LABEL[ticket.type] ?? KIND_LABEL.docs!;
  const statusCls = STATUS_TO_CLASS[status];
  const priCls = ticket.priority.toLowerCase();
  return (
    <CourseLink
      route={{ screen: 'ticket', ticketId: ticket.id }}
      onNavigate={() => onClick?.()}
      className={`ticket trow course-link ${statusCls} ${isCurrent ? 'is-current' : ''}`}
    >
      <span className="id">{ticket.id}</span>
      <span className="stat-dot" />
      <span className="title">
        {ticket.title}
        {isCurrent && <span className="now-tag">сейчас</span>}
      </span>
      <span className={`label-pill ${meta.cls}`}>{meta.label}</span>
      <span className={`pri-pill ${priCls}`}>{ticket.priority}</span>
      <span className="est">{ticket.estimateMin}м</span>
    </CourseLink>
  );
}
